module.exports = __webpack_public_path__ + "media/drifto-gameplay.7e0daea8.mp4";